<template>
	<c-dialog ref="dialog" title="物料清单" width="600" mode="slide" :button="false" mask-close>
		<c-tree ref="tree" :data="treeData" :select="false" style="margin: 10px;">
			<template #icon="{data}">
				<c-state dict="productSourceName" :value="data.product_source" style="padding-right:5px;"></c-state>
				<c-state dict="productTypeName" :value="data.product_type"></c-state>
			</template>
		</c-tree>
	</c-dialog>
</template>

<script>
	export default {
		data() {
			return {
				treeData: []
			}
		},
		methods: {
			open(data) {
				this.request({
					url: '/product/children/all_list',
					data: {
						product_ids: [data.product_id]
					},
					loading: true,
					success: data => {
						if (!data[0].childProduct) {
							this.$message({
								message: '该产品暂无物料清单'
							});
							return;
						}
						!function loop(list) {
							list && list.forEach(item => {
								item.id = item.product_id;
								item.pId = item.parent_product_id;
								item.name = `${item.product_code} - ${item.product_name}${item.product_spec ? ` [${item.product_spec}]` : ''}`;
								item.data = item;
								if (item.childProduct) {
									item.children = loop.call(this, item.childProduct);
								} else {
									item.leaf = true;
								}
							});
							return list;
						}.call(this, data);
						this.treeData = data;
						this.$refs.tree.expandNode();
						this.$refs.dialog.open();
					}
				});
			}
		}
	}
</script>
<style lang="stylus" scoped>
</style>